import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import SubRoleManagement from '../SubRoleManagement';

function SubRoleManagementLayout() {
  return (
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Container maxWidth="xxl" sx={{ mt: 2, mb: 2 }}>
          <SubRoleManagement />
        </Container>
      </Box>
    </>
  );
}

export default SubRoleManagementLayout; 